import axios from "axios";
import AuthService from '../Auth/AuthService';
//import config from '../Auth/Config';

export default class DatatableService extends AuthService {

    findAll() {
        return axios({
            method: 'get',
            url: this.api_url + 'datatable',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        }).then(res => res.data);
    }
    findAllExternal() {
        return axios({
            method: 'get',
            url: this.api_url + 'datatable/external',
            withCredentials: true,
        }).then(res => res.data);
    }
    findByDatatableByUserId(id) {
        return axios({
            method: 'get',
            url: this.api_url + 'datatable/' + id,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        }).then(res => res.data);
    }
    findByUsuarioByDatableId(id) {
        return axios({
            method: 'get',
            url: this.api_url + 'datatable/responsaveis/' + id,
            withCredentials: true,
        }).then(res => res.data);
    }
    create(data) {
        return axios({
            method: 'post',
            url: this.api_url + 'datatable',
            data: data,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
    update(id, data) {
        return axios({
            method: 'put',
            url: this.api_url + 'datatable/' + id,
            data: data,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
    updateStatus(id, data) {
        return axios({
            method: 'put',
            url: this.api_url + 'datatable/status/' + id,
            withCredentials: true,
            data: data,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
                'Content-Type': 'application/json'
            }
        });
    }
    delete(id) {
        return axios({
            method: 'delete',
            url: this.api_url + 'datatable/' + id,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
}
